export default {
  "ALL": -2,
  "STANDARD": -1,
}